(ns hai.admin-ui.users.contacts.routes
  (:require
   [hai.admin-ui.users.contacts.edit :as edit]
   [hai.admin-ui.users.contacts.table :as table]
   [hai.ui.icons :as icons]
   [hai.web-app.routing :as routing]))

(defn routes
  []
  [(-> ["/contacts"
        {::routing/window-title "Contacts"
         :label/short "Contacts"
         :icon icons/outlined-groups}
        ["" {:name        :contacts/table
             :label       "Contacts"
             :breadcrumbs ["Contacts"]
             :view        table/page}]]
       (into (edit/routes)))])
